import React from 'react';

const NextDestinationModal = ({ destinations, onNext, onClose }) => (
  <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-[100]">
    <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
      <h3 className="text-2xl font-bold text-slate-900 mb-4">¡Parada Completada!</h3>

      {(destinations || []).length > 0 ? (
        <>
          <p className="text-slate-600 mb-6">¿Cuál es tu próximo destino?</p>

          <div className="space-y-2 max-h-64 overflow-y-auto">
            {destinations.map((dest) => (
              <button
                key={dest.id}
                onClick={() => onNext(dest)}
                className="w-full text-left p-3 rounded-md bg-slate-100 hover:bg-blue-100 transition-colors font-semibold text-slate-800"
              >
                #{dest.order + 1}: {dest.name}
              </button>
            ))}
          </div>

          <div className="mt-6 space-y-2">
            <button
              onClick={onClose}
              className="w-full bg-slate-200 text-slate-800 py-2 px-4 rounded-md hover:bg-slate-300"
            >
              Decidir más tarde
            </button>
          </div>
        </>
      ) : (
        <>
          <p className="text-slate-600 mb-6">
            Ya completaste todas las paradas. La ruta queda pendiente de cierre administrativo.
          </p>

          <button
            onClick={onClose}
            className="w-full bg-slate-900 text-white font-bold py-3 rounded-md hover:bg-slate-800"
          >
            Entendido
          </button>
        </>
      )}
    </div>
  </div>
);

export default NextDestinationModal;
